module.exports = __webpack_public_path__ + "static/media/Jason Gardner.9cb1c868.png";